import React, { useEffect, useState } from "react";
import "../pdfViewer.css";

export default function PdfViewer({
  file = "/MEDITATIVE_EXPERIENCES.pdf",
  title = "PDF Viewer",
}) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    setIsMobile(checkMobile);
  }, []);

  if (isMobile) {
    return (
      <div className="pdf-container">
        <h1 className="pdf-title">{title}</h1>
        <p style={{ textAlign: "center", padding: "20px" }}>
          Tap below to view the PDF:
        </p>
        <a
          href={file}
          target="_blank"
          rel="noopener noreferrer"
          className="pdf-button"
        >
          Open PDF
        </a>
      </div>
    );
  }

  return (
    <div className="pdf-container">
      <h1 className="pdf-title">{title}</h1>
      <div className="pdf-iframe-wrapper">
        <iframe
          src={file}
          className="pdf-iframe"
          title={title}
          allow="fullscreen"
        ></iframe>
      </div>
    </div>
  );
}
